import { DOCUMENT, documentFactory } from 'src/app/feature/injection-token/document';

import { AnalyticsClickDirective } from './analytics-click.directive';
import { AnalyticsEffects } from './analytics.effects';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [AnalyticsClickDirective],
	exports: [AnalyticsClickDirective],
	imports: [EffectsModule.forFeature([AnalyticsEffects])],
	providers: [
		{
			provide: DOCUMENT,
			useFactory: documentFactory,
		},
	],
})
export class AnalyticsModule {}
